import AxiosClient from './clients/axios'

const find = async (option, value) => {
  const url = `/trackingRuler?${option}=${value}`
  const response = await AxiosClient.get(url, { headers: {
    'x-api-key': process.env.VUE_APP_CUSTOMER_PANEL_API_KEY
  } })
  return response.data
}

export {
  find
}

